module.exports = __webpack_public_path__ + "img/08219203001661.feec0a12.png";